<template>
  <v-app>
    <v-main>
      <AlertComponent />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AlertComponent from "@/components/alertComponent.vue";
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  name: "App",
  components: {
    AlertComponent,
  },
  setup() {
    const store = useStore();
    
    // Make these available but don't apply them globally
    const backgroundClass = computed(() => store.getters['theme/backgroundClass']);
    const cardClass = computed(() => store.getters['theme/cardClass']);
    
    return {
      backgroundClass,
      cardClass
    };
  }
};
</script>